import { Button, Col, ConfigProvider, DatePicker, Form, Input, Modal, Row, Select, Spin, Table, Tag } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../../variables/api/axiosInstance";
import { CheckCircleTwoTone, ExclamationCircleFilled, FilePdfFilled } from "@ant-design/icons";
import SideBar from "../../../components/SideBar";
import NavBar from "../../../components/NavBar";
import { toast } from "react-toastify";
import { frenchDate } from "../../../variables/functions";
import { displayNumbers } from "../../../variables/numbersFunctions";
import Footer from "../../../components/Footer";
import frFR from "antd/locale/fr_FR";
import RecuDeVersementDePrimeEnCompagnie from "../../production/components/docs/RecuDeVersementDePrimeEnCompagnie";
import dayjs from "dayjs";
import GeneratedBordereauCommissions from "./GeneratedBordereauCommissions";
import { StatCard } from "../../../components/statistics/StatCard";
import { COLORS } from "../../../components/ui/colors";
const { confirm } = Modal;
const { Option } = Select;

const CommissionsGenerees = () => {
    const [datas, setDatas] = useState([]);
    const [total, setTotal] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [dataSum, setDataSum] = useState(0);
    const [todayDatas, setTodayDatas] = useState([]);
    const [selecting, setSelecting] = useState(false);
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [todayDataSum, setTodayDataSum] = useState(0);
    const [monthDatas, setMonthDatas] = useState([]);
    const [monthDataSum, setMonthDataSum] = useState(0);
    const [nonCashedDatas, setNonCashedDatas] = useState([]);
    const [nonCashedDataSum, setNonCashedDataSum] = useState(0);
    const [loadingData, setLoadingData] = useState(true);
    const [filteredInfo, setFilteredInfo] = useState({});
    const [sortedInfo, setSortedInfo] = useState({});
    const [modalModePaiement, setModalModePaiement] = useState(false);
    const [contractToPay, setContractToPay] = useState([]);
    const [numeroPaiement, setNumeroPaiement] = useState("P");
    const [modePaiement, setModePaiement] = useState("");
    const [modePaiementForm] = Form.useForm();
    const [banques, setBanques] = useState([]);
    const [banque, setBanque] = useState("BANQUE");
    const [hidden, setHidden] = useState(false);
    const [dateF, setDateF] = useState([]);
    const [openModalBorderau, setOpenModalBorderau] = useState(false);
    const [loadingBordereau, setLoadingBordereau] = useState(false);
    const [dateVirement, setDateVirement] = useState(null);

    const handleChange = (pagination, filters, sorter) => {
        setCurrentPage(pagination.current);
        setPageSize(pagination.pageSize);
        setFilteredInfo(filters);
        setSortedInfo(sorter);
    };

    const navigate = useNavigate();

    const onSelectChange = (newSelectedRowKeys, rows) => {
        setSelecting(true);
        setSelectedRows(rows);
        setSelectedRowKeys(newSelectedRowKeys);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };

    useEffect(() => {
        axiosInstance
            .get(`/api/reglement/avec-commission`, {
                params: {
                    page: currentPage - 1,
                    size: pageSize,
                    search: "",
                    startDate: dateF ? dateF[0] : null,
                    endDate: dateF ? dateF.length > 1 ? dateF[1] : null : null,
                    compagnie: "",
                },
            })
            .then((res) => {
                console.log("jaiiiille: ", res);
                setDatas(res.data.content);
                setTotal(res.data.totalElements);
                setLoadingData(false);
            })
            .catch((err) => {
                console.log("Err: ", err);
                setLoadingData(false);
            });

        axiosInstance
            .get(`/api/parametre/type/BANQUE`)
            .then((res) => {
                setBanques(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
    }, [pageSize, currentPage, dateF]);

    const columns = [
        {
            title: "Assuré",
            dataIndex: "nom",
            key: "nom",
            render: (_, record) => (
                <>
                    {`${record.nomSouscripteur} ${record.prenomSouscripteur ? record.prenomSouscripteur : ""}`}{" "}
                </>
            ),
        },
        {
            title: "Numéro Police",
            dataIndex: "numeroPolice",
            key: "numeroPolice",
            render: (_, record) => <>{`${record.numeroPolice}`} </>,
        },
        {
            title: "Avenant",
            dataIndex: "avenant",
            key: "avenant",
            render: (_, record) => (
                <>{record?.avenant ? record?.avenant : "AN"} </>
            ),
        },
        {
            title: "Prime",
            dataIndex: "montant",
            key: "montant",
            render: (_, record) => (
                <>
                    {displayNumbers(record.montant)}{" "}
                </>
            ),
        },
        {
            title: "Taux de commission",
            dataIndex: "tauxCommission",
            key: "tauxCommission",
            render: (_, record) => (
                <>
                    {displayNumbers(record.tauxCommission || 0)}%{" "}
                </>
            ),
        },
        {
            title: "Commission",
            dataIndex: "commission",
            key: "commission",
            render: (_, record) => (
                <>
                    {displayNumbers(record.commission)}{" "}
                </>
            ),
        },
        {
            title: "Mode de paiement",
            dataIndex: "modePaiement",
            key: "modePaiement",
            render: (_, record) => (
                <>
                    {record.modePaiement === "ESPECES" ? (
                        <Tag color="blue">ESPECES</Tag>
                    ) : record.modePaiement === "RISTOURNE" ? (
                        <Tag color="green">RISTOURNE</Tag>
                    ) : record.modePaiement && record.modePaiement !== "-" ? (
                        <Tag color="yellow">{record.modePaiement}</Tag>
                    ) : null}{" "}
                </>
            ),
        },
        {
            title: "Date règlement",
            dataIndex: "dateReglement",
            key: "dateReglement",
            render: (_, record) => (
                <>{record.modePaiement ? frenchDate(record.dateReglement) : "-"} </>
            ),
        },
        {
            title: "N° bordereau",
            dataIndex: "bordereau",
            key: "bordereau",
            render: (_, record) => <Tag color="orange" >{record.bordereau ? record.bordereau : "-"}</Tag>,
        },
        {
            title: "Actions",
            dataIndex: "actions",
            key: "7",
            render: (_, record) => (
                <>
                    <button
                        type="button"
                        class="btn btn-primary btn-icon rounded-pill"
                        onClick={() =>
                            navigate(`/details-contrat/${record.contratCodeId}`)
                        }
                    >
                        <i class="bx bx-dots-vertical-rounded"></i>
                    </button>
                </>
            ),
        },
    ];

    const alertReglement = (contractToPay) => {
        // console.log(numeroPaiement);
        if (contractToPay.length > 1) {
            reglementContrat(contractToPay);
        } else {
            confirm({
                title: "Etes-vous sûr de vouloir régler ce contrat?",
                icon: <ExclamationCircleFilled />,
                content: "Toutes vos actions sont historisées!",
                okText: "Oui régler",
                okType: "danger",
                cancelText: "Annuler",
                onOk() {
                    console.log("OK");
                    reglementContrat(contractToPay);
                },
                onCancel() {
                    console.log("Cancel");
                },
            });
        }
    };

    const reglementContrat = (data) => {
        let regs = [];
        data.forEach(element => {
            regs.push(element.reglement);
        });
        axiosInstance
            .post(
                `/api/reglement/versements-en-compagnie/${modePaiement}/${numeroPaiement}/${banque}/`, JSON.stringify(regs))
            .then((res) => {
                window.location.reload();
                toast("Versements effectués avec succès");
                // console.log(res.data);
                res.data = null;
            })
            .catch((err) => {
                console.log(err);
                toast("Erreur lors des versements");
            });

    };

    const genererBorderau = (rows) => {
        if (rows.length > 0) {
            console.log("Rows selected", rows);
            setOpenModalBorderau(true);
        } else {
            toast("Veuillez choisir au moins un contrat");
        }
    };

    const MyFooter = () => {
        console.log(selectedRows);
        return (
            <div class="row">
                <div class="col-sm-4">
                    <Button
                        onClick={() => {
                            genererBorderau(selectedRows);
                        }}
                        color="success"
                        icon={<FilePdfFilled />}
                        style={{
                            color: "purple",
                        }}
                        title="Encaissement"
                    >
                        Générer le borderau
                    </Button>
                </div>

            </div>
        );
    };

    const validateBordereau = () => {
        if (selectedRows.length > 0) {
            setLoadingBordereau(true);
            axiosInstance.post(`/api/bordereau/commissions`, JSON.stringify(selectedRows))
                .then((res) => {
                    console.log(res.data);
                    toast("Bordereau validé avec succès");
                    setLoadingBordereau(false);
                    setOpenModalBorderau(false);
                    window.location.reload();
                }).catch((err) => {
                    console.log(err);
                    toast("Erreur lors de la validation du bordereau");
                    setLoadingBordereau(false);
                });
        }
    }

    return (
        <div class="layout-wrapper layout-content-navbar  ">
            <div class="layout-container">
                <SideBar currentMenu={"COURTIERS"} />

                {/* <!-- Layout container --> */}
                <div class="layout-page">
                    <NavBar />

                    {/* <!-- Content wrapper --> */}
                    <div class="content-wrapper">
                        {/* <!-- Content --> */}
                        <div class="container-xxl flex-grow-1 container-p-y">
                            <Row style={{ marginBottom: "15px", justifyContent: "space-between" }}>
                                <Col
                                    flex="1" // ✅ prend la même largeur que les autres
                                    style={{
                                        minWidth: "180px", // optionnel, empêche les cards trop petites
                                        marginRight: "10px",
                                    }}
                                >
                                    <StatCard
                                        title="Commissions"
                                        subtitle="du jour"
                                        value={`${todayDatas?.length} (${displayNumbers(Math.trunc(todayDataSum))} FCFA)`}
                                        icon="bx bx-calendar-check "
                                        iconBg={COLORS.primary}
                                        gradient={COLORS.primary}
                                    />
                                </Col>
                                <Col
                                    flex="1" // ✅ prend la même largeur que les autres
                                    style={{
                                        minWidth: "180px", // optionnel, empêche les cards trop petites
                                        marginRight: "10px",
                                    }}
                                >
                                    <StatCard
                                        title="Commissions"
                                        subtitle="du mois"
                                        value={`${monthDatas?.length} (${displayNumbers(Math.trunc(monthDataSum))} FCFA)`}
                                        icon="bx bx-calendar-event"
                                        iconBg={COLORS.primary}
                                        gradient={COLORS.primary}
                                    />
                                </Col>
                                <Col
                                    flex="1" // ✅ prend la même largeur que les autres
                                    style={{
                                        minWidth: "180px", // optionnel, empêche les cards trop petites
                                        marginRight: "10px",
                                    }}
                                >
                                    <StatCard
                                        title="Commissions"
                                        subtitle="total"
                                        value={`${datas?.length} (${displayNumbers(Math.trunc(dataSum))} FCFA)`}
                                        icon="bx bx-line-chart"
                                        iconBg={COLORS.primary}
                                        gradient={COLORS.primary}
                                    />
                                </Col>
                                <Col
                                    flex="1" // ✅ prend la même largeur que les autres
                                    style={{
                                        minWidth: "180px", // optionnel, empêche les cards trop petites
                                        marginRight: "10px",
                                    }}
                                >
                                    <StatCard
                                        title="Commissions Payées"
                                        subtitle="Total"
                                        value={`${nonCashedDatas?.length} (${displayNumbers(Math.trunc(nonCashedDataSum))} FCFA)`}
                                        icon="bx bx-wallet"
                                        iconBg={COLORS.primary}
                                        gradient={COLORS.primary}
                                    />
                                </Col>
                            </Row>
                            <div class="card">
                                <ConfigProvider locale={frFR}>
                                    <Spin spinning={loadingData}>
                                        <Table
                                            rowSelection={rowSelection}
                                            columns={columns}
                                            dataSource={datas}
                                            onChange={handleChange}
                                            rowKey="codeId"
                                            footer={() => <MyFooter />}
                                            pagination={{ total: total, showSizeChanger: true }}
                                        />
                                    </Spin>
                                </ConfigProvider>
                            </div>
                            <Modal
                                title="Bordereau de versement de primes"
                                centered
                                open={openModalBorderau}
                                onCancel={() => {
                                    setOpenModalBorderau(false);
                                }}
                                width={1200}
                                zIndex={2000}
                            >
                                <GeneratedBordereauCommissions
                                    emissions={selectedRows}
                                />
                                <Button
                                    type="primary"
                                    onClick={() => {
                                        validateBordereau();
                                    }}
                                    icon={<CheckCircleTwoTone />}
                                    style={{ marginTop: "50px", backgroundColor: "gray" }}
                                    loading={loadingBordereau}
                                >
                                    Valider le bordereau
                                </Button>

                            </Modal>
                        </div>
                        {/* <!-- / Content --> */}

                        {/* <!-- Footer --> */}
                        <Footer />
                        {/* <!-- / Footer --> */}

                        <div class="content-backdrop fade"></div>
                    </div>
                    {/* <!-- Content wrapper --> */}
                </div>
                {/* <!-- / Layout page --> */}
            </div>
            <Modal
                title="Mode de paiement"
                centered
                open={modalModePaiement}
                onOk={() => {
                    alertReglement(contractToPay);
                }}
                onCancel={() => {
                    setModalModePaiement(false);
                }}
            >
                <>
                    <div className="container" justify="center">
                        <div className="grid-item" lg={12}>
                            <Form
                                form={modePaiementForm}
                                layout="vertical"
                                name="userForm"
                            >
                                <Form.Item
                                    name="modePaiement"
                                    label="Mode de paiement"
                                    rules={[
                                        {
                                            required: true,
                                        },
                                    ]}
                                >
                                    <Select
                                        onChange={(value) => {
                                            console.log(value);
                                            setModePaiement(value);
                                        }}
                                        placeholder="Selectionnez votre mode de paiement"
                                    >
                                        <Option value="ESPECES"> ESPECES </Option>
                                        <Option value="BANQUE">BANQUE (Chèque)</Option>
                                        <Option value="VIREMENT">BANQUE (Virement)</Option>
                                        <Option value="MOBILE_MONEY">Mixx By Yas / Moov Money</Option>
                                    </Select>
                                </Form.Item>
                                {modePaiement === "BANQUE" ||
                                    modePaiement === "MOBILE_MONEY" ? (
                                    <Form.Item
                                        name="numeroPaiement"
                                        label={
                                            modePaiement === "BANQUE"
                                                ? "Numero de chèque"
                                                : modePaiement === "MOBILE_MONEY"
                                                    ? "Numero Mixx By Yas / Moov Money"
                                                    : ""
                                        }
                                        rules={[
                                            {
                                                required: true,
                                                message: "Veuillez renseigner le champ!",
                                            },
                                        ]}
                                    >
                                        <Input
                                            placeholder={
                                                modePaiement === "BANQUE"
                                                    ? "Le numero de chèque"
                                                    : modePaiement === "MOBILE_MONEY"
                                                        ? "Le numero de téléphone MOOV (Moov Money) / Yas (Mixx By Yas)"
                                                        : ""
                                            }
                                            onChange={(value) => {
                                                console.log(value.target.value);
                                                setNumeroPaiement(value.target.value);
                                            }}
                                        />
                                    </Form.Item>
                                ) : null}
                                {modePaiement === "BANQUE" || modePaiement === "VIREMENT" ? (
                                    <Form.Item
                                        name="banque"
                                        label="Banque"
                                        rules={[
                                            {
                                                required: true,
                                            },
                                        ]}
                                    >
                                        <Select
                                            onChange={(value) => {
                                                console.log(value);
                                                setBanque(value);
                                            }}
                                            placeholder="Selectionnez la banque"
                                        >
                                            {banques.map((b) => (
                                                <Option
                                                    key={b.parametreId}
                                                    value={b.libelleParametre}
                                                >
                                                    {b.libelleParametre}
                                                </Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                ) : null}
                                {modePaiement === "MOBILE_MONEY" || modePaiement === "VIREMENT" ? (
                                    <Form.Item
                                        name="referencePaiement"
                                        label="Reférence du paiement"
                                        rules={[
                                            {
                                                required: true,
                                                message: "Veuillez renseigner le champ!",
                                            },
                                        ]}
                                    >
                                        <Input
                                            placeholder={"Le numero de reférence"}
                                            onChange={(value) => {
                                                setNumeroPaiement(value.target.value);
                                            }}
                                        />
                                    </Form.Item>
                                ) : null}
                                {modePaiement === "VIREMENT" ? (
                                    <Form.Item
                                        name="dateVirement"
                                        label="Date du virement"
                                        rules={[
                                            {
                                                required: true,
                                                message: "Veuillez renseigner le champ!",
                                            },
                                        ]}
                                    >
                                        <DatePicker
                                            placeholder={"La date du virement"}
                                            onChange={(_, value) => {
                                                setDateVirement(value);
                                            }}
                                            style={{ width: "100%" }}
                                            disabledDate={(current) => current && current > dayjs().endOf('day')}
                                        />
                                    </Form.Item>
                                ) : null}
                            </Form>
                        </div>
                    </div>
                </>
            </Modal>
            {/* <!-- Overlay --> */}
            <div class="layout-overlay layout-menu-toggle"></div>

            {/* <!-- Drag Target Area To SlideIn Menu On Small Screens --> */}
            <div class="drag-target"></div>
        </div>
    );
}

export default CommissionsGenerees